export default "__VITE_ASSET__DIJAD1nv__"